import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-yoga-blog',
  templateUrl: './yoga-blog.component.html',
  styleUrls: ['./yoga-blog.component.scss']
})
export class YogaBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
